import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * The controls that filter a table, directly above the table they filter.
 *
 * Rendered inside the table's own `<Paper>`, above its `<TableContainer>`, so the border makes the claim
 * that the position implies. In the page header they would sit a screen away from the first row, and
 * nothing would say which table they belonged to.
 *
 * Rules: dev-utils/Progress/AI Updates/Conventions/08-Back-Office-Tables.md.
 */
export const TableFilters = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 2,
      px: 2,
      py: 1.75,
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    {children}
  </Box>
);
